'use client'

import HamburguerIcon from '@/components/icons/hamburguer'
import { IconButton } from '@/components/ui/icon-button'
import { useContext } from 'react'
import { LayoutContext } from '../layout-context'

export default function HeaderSidebarTrigger() {
  const { sidebarOpen, onSidebarOpenChange } = useContext(LayoutContext)

  return (
    <IconButton
      variant='outline'
      size='xs'
      // remover propriedades CSS depois da
      // padronização dos estilos de design
      // com o novo design system
      bgColor='transparent'
      color='#8C7996'
      _before={{
        content: '""',
        backgroundImage:
          'radial-gradient(circle at center, rgba(241, 221, 249, 0.1) 5%, transparent 60%)',
        opacity: 0,
        position: 'absolute',
        left: 0,
        right: 0,
        bottom: '-1px',
        transition: 'opacity 200ms ease',
        h: '1px',
        w: 'full',
      }}
      _hover={{
        borderColor: '#271C2B',
        bgColor: '#201523',
        bgImage:
          'radial-gradient(50.92% 50% at 50% 100%, rgba(159, 131, 173, 0.10) 0%, rgba(0, 0, 0, 0.00) 100%)',
        _before: {
          opacity: 1,
        },
      }}
      // -----------------------------
      aria-label='Open sidebar'
      onClick={() => {
        onSidebarOpenChange(!sidebarOpen)
      }}
    >
      <HamburguerIcon size='md' />
    </IconButton>
  )
}
